import { useEffect } from "react";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

const GET_BACKGROUND_JOBS = gql`
  query GetBackgroundJobs {
      requests {
      origin
      timestamp
      status
      requestId
      requestBy
      message
      errors
      request
    }
  }
`;

const ACTIVE_STATUSES = ["QUEUED", "IN_PROGRESS", "NEW"];

const ACTIVE_POLL_INTERVAL = Number(process.env.REACT_APP_GRAPHQL_API_POLL_INTERVAL) || 7000;
const IDLE_POLL_INTERVAL = Number(process.env.REACT_APP_GRAPHQL_API_IDLE_POLL_INTERVAL) || 120000;

export function computeActiveCount(jobs) {
  return jobs.filter(j => ACTIVE_STATUSES.includes(j.status)).length;
}

export function getJobDescription(job) {
  return job.request?.requestAdditionalInfo?.description ?? "";
}

export function getJobCooperative(job) {
  return job.request?.requestAdditionalInfo?.cooperative ?? "";
}

export function useBackgroundJobs() {
  const { data, loading, error, startPolling } = useQuery(GET_BACKGROUND_JOBS, {
    pollInterval: ACTIVE_POLL_INTERVAL
  });

  const jobs = data ? data.requests : [];
  const activeCount = computeActiveCount(jobs);

  useEffect(() => {
    startPolling(activeCount > 0 ? ACTIVE_POLL_INTERVAL : IDLE_POLL_INTERVAL);
  }, [activeCount]);

  return { jobs, activeCount, loading, error };
}
